import { useNavigate, matchPath, useLocation } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import { PagePath } from '@/routes/paths';
import useStore from '@/stores/sider-menu';
import MenuIcon from '@/layouts/main-layout/components/menu-icon';
import MenuItem from '@/layouts/main-layout/components/menu-item';

export default function InquiriesNav() {
  const { collapsed } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = !!matchPath(PagePath.inquiries, location.pathname);

  const handleClick = () => navigate(PagePath.inquiries);

  if (collapsed) {
    return (
      <MenuIcon onClick={handleClick} title="Inquiries" isActive={isActive}>
        <ClipboardList size={16} color="#737373" />
      </MenuIcon>
    );
  }

  return (
    <MenuItem
      className={isActive ? 'bg-[#E5E5E5]/65' : ''}
      onClick={handleClick}
      icon={<ClipboardList size={16} color="#737373" />}
    >
      Inquiries
    </MenuItem>
  );
}
